import React from 'react';
import Header from './Header';
import Footer from './Footer';

function Layout({ children, user, onSignOut }) {
  return (
    <div id="page">
      <Header user={user} onSignOut={onSignOut} />
      <div id="main">
        {children}
      </div>
      <Footer />
    </div>
  );
}

export default Layout;
